import PropTypes from "prop-types";
import prevSlideIcon from "../../../assets/icons/prevSlide.svg";
import classes from "./PrevBtn.module.css";

const PrevBtn = (props) => {
  const { className, ...rest } = props;

  return (
    <button className={classes["prev-slide-btn"]} {...rest}>
      <img
        src={prevSlideIcon}
        alt="prev slide"
        className={classes["prev-slide-btn__icon"]}
      />
    </button>
  );
};

export default PrevBtn;

PrevBtn.propTypes = {
  className: PropTypes.string,
};
